/**
 * @generated SignedSource<<93ff54693ba3109228990837eccd133c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductFamily = "BUSINESS" | "ENTERPRISE" | "ENTERPRISE_PLUS" | "FEEDBACK" | "FREE" | "MEETING_RECORDER" | "OBJECTIVES" | "PRO" | "SOLOPRENEUR";
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type NavbarAccountDropdown_viewer$data = {
  readonly account: {
    readonly allowInviting: boolean | null;
    readonly billingAccount: {
      readonly hasAccessToAnalytics: boolean;
      readonly product: {
        readonly family: ProductFamily;
      };
      readonly subscriptionLabel: string;
    };
    readonly id: string;
    readonly logo: string;
    readonly name: string;
  };
  readonly activeDelegation: {
    readonly delegate: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
    };
    readonly delegator: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
    };
    readonly id: string;
  } | null;
  readonly delegators: ReadonlyArray<{
    readonly delegator: {
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
    };
    readonly expiryDate: string | null;
    readonly id: string;
  }>;
  readonly hasAccessToCopilot: boolean;
  readonly hasAdminAccess: boolean;
  readonly user: {
    readonly email: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
    readonly internalAttributes: {
      readonly isAccountAdmin: boolean;
      readonly isManager: boolean;
    } | null;
    readonly isGuest: boolean;
    readonly type: UserType;
  };
  readonly viewer: {
    readonly lastUsedDesktopApp: string | null;
    readonly remainingMeetingRecordingCredits: number;
    readonly " $fragmentSpreads": FragmentRefs<"featureFlag_useCopilotPaywallsOn_viewer">;
  };
  readonly " $fragmentType": "NavbarAccountDropdown_viewer";
};
export type NavbarAccountDropdown_viewer$key = {
  readonly " $data"?: NavbarAccountDropdown_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavbarAccountDropdown_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v3/*: any*/),
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavbarAccountDropdown_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAdminAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowInviting",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "family",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": "hasAccessToAnalytics",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "analytics"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"analytics\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastUsedDesktopApp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingMeetingRecordingCredits",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "featureFlag_useCopilotPaywallsOn_viewer"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserInternalAttributes",
          "kind": "LinkedField",
          "name": "internalAttributes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountAdmin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isManager",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegation",
      "kind": "LinkedField",
      "name": "delegators",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "delegator",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expiryDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegation",
      "kind": "LinkedField",
      "name": "activeDelegation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "delegator",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "delegate",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "21baeef7a51453f608764df5a8d0e22d";

export default node;
